// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__6wXgv","textContainer":"style_textContainer__uu4Fc"};